








import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { fixedHtmlData } from "@/services/posts/postTypes/fixedhtml";
import { BehaviorEnum } from "@/services/posts/types";
@Component
export default class ImageSubRenderComponent extends Vue {
    @Prop() properties!: fixedHtmlData;
    @Prop() imageStyle!: string;

    // Watch
    @Watch("properties", { immediate: true, deep: true })
    onPropertiesDataChanged(value: any) {
        this.setDisplayImageStyles();
    }

    // -Data Properties-
    imageDisplayStyles= "";

    // Computed
    get src() {
        return this.properties.src || this.generatePlaceholderImage();
    }

    // Methods
    generatePlaceholderImage() {
        return "https://placehold.jp/" + this.properties.position.channelWidth + "x" + this.properties.position.channelHeight + ".png";
    }

    // Lifecycle Hooks
    mounted() {
        this.$emit("setDuration", 0);
    }

    setDisplayImageStyles() {
        this.imageDisplayStyles = "";
        if (this.properties.behavior === BehaviorEnum.adjust) {
            const ratio = Math.max(this.properties.position.channelWidth / this.properties.position.imgWidth, this.properties.position.channelHeight / this.properties.position.imgHeight);
            const ratio2 = Math.max((this.properties.position.channelWidth * this.properties.position.factor) / this.properties.position.cropSizeWidth, (this.properties.position.channelHeight * this.properties.position.factor) / this.properties.position.cropSizeHeight);
            this.imageDisplayStyles = `
                transform: scale(${ratio * ratio2});
                margin-left: ${-this.properties.position.x * ratio2}px;
                margin-top: ${-this.properties.position.y * ratio2}px;
            `;
        }

        if (this.properties.behavior === BehaviorEnum.crop) {
            const ratio = Math.max(this.properties.position.channelWidth / this.properties.position.imgWidth, this.properties.position.channelHeight / this.properties.position.imgHeight);
            if (ratio < 1) {
                this.imageDisplayStyles = `transform: scale(${ratio}) translate(-50%, -50%)`;
            }
        }

        if (this.properties.behavior === BehaviorEnum.letterBox) {
            const ratio = Math.min(this.properties.position.channelWidth / this.properties.position.imgWidth, this.properties.position.channelHeight / this.properties.position.imgHeight);
            if (this.properties.position.imgWidth > this.properties.position.channelWidth || this.properties.position.imgHeight > this.properties.position.channelHeight) {
                this.imageDisplayStyles = `
                    width: ${this.properties.position.imgWidth * ratio}px;
                    height: ${this.properties.position.imgHeight * ratio}px;
                `;
            }
        }
    }
}
